"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizationModeStore = void 0;
const session_storage_store_1 = require("./session-storage.store");
const CUSTOMIZATION_MODE = "@smallstack/customization-mode";
class CustomizationModeStore extends session_storage_store_1.SessionStorageStore {
    constructor() {
        super({ key: CUSTOMIZATION_MODE, parser: "boolean" });
    }
}
exports.CustomizationModeStore = CustomizationModeStore;
